module.exports = __webpack_public_path__ + "static/media/notification-icon-truck.417d0dfd.svg";